import { Component, Input } from '@angular/core'

type TSkeletonWidth = 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl' | 'full'

@Component({
    selector: 'app-skeleton-card',
    templateUrl: './skeleton-card.component.html',
    styleUrls: ['./skeleton-card.component.scss'],
})
export class SkeletonCardComponent {
    //default values
    @Input() showHeader = true
    @Input() headerWidth: TSkeletonWidth = 'm'
    @Input() showSubheader = false
    @Input() subheaderWidth: TSkeletonWidth = 's'
    @Input() lines = 3
    @Input() lineWidths: TSkeletonWidth[] = []
    @Input() showActions = false
    @Input() actionsCount = 0

    get lineArray(): number[] {
        return Array(this.lines).fill(0)
    }

    get actionArray(): number[] {
        return Array(this.actionsCount).fill(0)
    }
}
